import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NOTIFICATIONS_API_BASE_URL } from '../../api-base-url.token';
import { UserOnlineResponseDto } from '../../schemas/user-online-admin/user-online-response.dto';

@Injectable({ providedIn: 'root' })
export class UserOnlineAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(NOTIFICATIONS_API_BASE_URL)}/UserOnlineAdmin`;

    getAll(organizationId?: number) {
        let params = new HttpParams();

        if (organizationId !== undefined) {
            params = params.set('organizationId', organizationId);
        }

        return this.builder
            .url(`${this.controllerUrl}/GetAll`)
            .get()
            .json<UserOnlineResponseDto[]>()
            .withHttpParams(params)
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetById`)
            .get()
            .json<UserOnlineResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
